import { Path, Svg } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const Confirm = withDefaultIconProps({ height: 20, width: 20 }, ({ color, ...rest }) => (
  <Svg {...rest} viewBox="0 0 20 20">
    <Path
      d="M8.55 15.92C8.55 15.92 8.56 15.92 8.57 15.92C8.74 15.91 8.89 15.82 8.98 15.68L15.76 4.86C15.91 4.62 15.84 4.3 15.6 4.16C15.37 4.01 15.05 4.08 14.9 4.32L8.5 14.52L5.07 10.09C4.9 9.86 4.58 9.82 4.36 10C4.13 10.17 4.09 10.49 4.26 10.71L8.14 15.72C8.24 15.85 8.39 15.92 8.55 15.92Z"
      fill={color}
    />
  </Svg>
));
